import type React from 'react';
import { SetupPendingPageView } from './SetupPendingPageView';
import { useSetupPendingPage } from './useSetupPendingPage';

/**
 * `/setup-pending` — where a BranchAdmin or Seller waits while their
 * organisation is still onboarding (the onboarding gate sends them here and
 * keeps them here). Full-screen: no sidebar, no navbar, no links into the
 * shell.
 */
export const SetupPendingPage: React.FC = () => {
    const page = useSetupPendingPage();

    return <SetupPendingPageView {...page} />;
};
